<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <navBar :tags="tags" :title="title" :subTitle="subTitle" :btnSave="false" :btnBack="true"
                @btnBackClick="handleBackClick"
        />

        <div :class="$style.body">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="item.clerk_name" :name="index+''" v-for="(item, index) in tabs" :key="item.id">
                    <Item :item="item"  :index="index"/>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import Item from './item/tabItem.vue'
    export default {
        data () {
            return {
                loading: false,
                tags: ['巡店', '巡店详情'],
                title: '门店',
                subTitle: '辅导评估',


                tabs: [],
                activeName: '0',

            }
        },
        components: {
            navBar,
            Item
        },
        computed: {
            isDisabled () {
                if (this.message) {
                    return false
                }
                return true
            }
        },
        created () {
            let obj = this.$store.getters.getInspection
            this.title = obj.storeName

            let index = this.$route.query.index

            if(index){
                this.activeName = index
            }

            this.setCheckItem()
        },
        methods: {

            setCheckItem(){
                let obj = this.$store.getters.getInspection
                let assessmentArray = obj.EvaluationOfTutoring
                if(assessmentArray){
                    for (let obj of assessmentArray){
                        this.tabs.push(obj)
                    }
                }
            },

            // tab切换
            handleClick(tab) {

                this.activeName = tab.name

            },
            // 返回按钮
            handleBackClick () {
                this.$router.push({
                    path: '/cruiseShop'
                })
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';
    .container {
        background: #fff;
        padding: 20px 20px;
        height: 100%;
        box-sizing: border-box;
        .body {

            .title {
                font-size:$fontSize;
                line-height:$fontSize;
                em {
                    display: inline-block;
                    margin-right: 50px;
                    color:#000000;
                }
                span {
                    display: inline-block;
                    color: #4a90e2;
                    margin-right: 30px;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/cruiseShop/assessment/index.vue